import React from "react";
import { NavigationLinks, Section } from "../../../components";
import {
  AcionarSeguro,
  BannerPages,
  CoberturasAdicionais,
  CoberturasBasicas,
  UsarAssistencia,
} from "../Sections";
import Assistencias from "../Sections/Assistencias";
import ImageNavigationLinks from "../../../assets/images/residencial/ilustracao-homem-casa.svg";

const CoberturasEAssistencias = () => {
  return (
    <>
      <BannerPages
        subtitle="As coberturas básicas são as que já vem no seu contrato e servem para cuidar do seu imóvel quando um imprevisto
         (sinistro) acontecer. Quando tudo for aprovado, nós pagamos uma indenização. Se quiser, também pode incluir coberturas adicionais."
        bannerTitle="Coberturas"
        contentWidth={{
          lg: 12,
          xl: 12,
        }}
      />
      <Section as={CoberturasBasicas} sectionName="Coberturas básicas" />
      <Section as={CoberturasAdicionais} sectionName="Coberturas adicionais" />
      <Section as={AcionarSeguro} sectionName="Quer acionar seu seguro?" />
      <BannerPages
        subtitle="Elas facilitam o seu dia a dia! Acione os serviços que contratou a qualquer momento, ou, se preferir, inclua mais assistências no seu contrato."
        bannerTitle="Assistências"
        contentWidth={{
          lg: 12,
          xl: 12,
        }}
        noBreadCrumbs
      />
      <Section as={Assistencias} sectionName="Assistências" />
      <Section as={UsarAssistencia} sectionName="Quer usar sua assistência?" />
      <Section
        as={NavigationLinks}
        sectionName="Ainda podemos te ajudar?"
        sectionTitle="Ainda podemos te ajudar?"
        imgSrc={ImageNavigationLinks}
      />
    </>
  );
};

export default CoberturasEAssistencias;
